import { CardsLayout } from "./cards-layout.js";
import { HorizontalLayout } from "./horizontal-layout.js";
import { useMediaQuery } from "../../utilities/index.js";
import { useTheme } from "@mui/material";
import React from "react";
export const AdditionalMaterials = () => {
    const theme = useTheme();
    const useHorizontalLayout = useMediaQuery(theme.breakpoints.up("sm"));
    return useHorizontalLayout ? React.createElement(HorizontalLayout, null) : React.createElement(CardsLayout, null);
};
//# sourceMappingURL=additional-materials.js.map